module.exports = __webpack_public_path__ + "img/flag.d96fd8df.svg";